var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"blockquote-footer mx-5 my-2 update"},[_vm._v("Дата обновления: "+_vm._s(_vm.date))])])}
var staticRenderFns = []

export { render, staticRenderFns }